import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@saleor/components/Grid";
import SingleSelectField from "@saleor/components/SingleSelectField";
import React from "react";
import { useIntl } from "react-intl";

export interface GenerateReportDialogProps {
  open: any;
  onClose: any;
  onSubmit: any;
}

const ReportTypes = [
  { label: "BI - Customer Report", value: "BI_CUSTOMER" },
  { label: "BI - Inventory Report", value: "BI_INVENTORY" },
  { label: "BI - Product Performance Report", value: "BI_PRODUCT_PERF" },
  { label: "BI - Sales Report", value: "BI_SALES" },
  { label: "BI - Voucher Report", value: "BI_VOUCHER" },
  { label: "Finance - Payout", value: "FINANCE_PAYOUT" },
  { label: "Finance - Sales Report", value: "FINANCE_SALES" }
];

const ReportFormats = [
  { label: "XLSX", value: "XLSX" },
  { label: "PDF", value: "PDF" }
];

const useStyles = makeStyles(
  () => ({
    buttonActionFlex: {
      flexDirection: "column"
    },
    buttonActions: {
      display: "flex",
      width: "100%"
    },
    buttonWidth: {
      margin: "3px",
      width: "100%"
    },
    singleSelectField: {
      "& label": {
        overflowX: "visible",
        width: "100%"
      }
    }
  }),
  { name: "GenerateReportDialog" }
);

const GenerateReportDialog: React.SFC<GenerateReportDialogProps> = props => {
  const { onClose, open, onSubmit } = props;

  const classes = useStyles(props);
  const intl = useIntl();
  const container = React.useRef<HTMLDivElement>();

  const [selectedReportType, setSelectedReportType] = React.useState(null);
  const [selectedReportFormat, setSelectedReportFormat] = React.useState(null);
  const [selectedReportStart, setSelectedReportStart] = React.useState(null);
  const [selectedReportEnd, setSelectedReportEnd] = React.useState(null);

  const handleSelectReportType = event => {
    setSelectedReportType(event.target.value);
  };

  const handleSelectReportFormat = event => {
    setSelectedReportFormat(event.target.value);
  };

  const handleSelectReportStart = event => {
    setSelectedReportStart(event.target.value);
  };

  const handleSelectReportEnd = event => {
    setSelectedReportEnd(event.target.value);
  };

  const handleSubmit = () => onSubmit();

  return (
    <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
      <>
        <DialogTitle>Generate Report</DialogTitle>
        <DialogContent ref={container}>
          <Grid variant="repeated">
            <SingleSelectField
              label={intl.formatMessage({
                defaultMessage: "Report Type"
              })}
              className={classes.singleSelectField}
              disabled={false}
              value={selectedReportType}
              onChange={handleSelectReportType}
              choices={ReportTypes}
              name="cancelType"
            />
            <SingleSelectField
              label={intl.formatMessage({
                defaultMessage: "Report Format"
              })}
              className={classes.singleSelectField}
              disabled={false}
              value={selectedReportFormat}
              onChange={handleSelectReportFormat}
              choices={ReportFormats}
              name="cancelType"
            />
            <TextField
              id="reportStart"
              className={classes.singleSelectField}
              label={intl.formatMessage({
                defaultMessage: "Start Date",
                description: "select report start date"
              })}
              type="date"
              name="reportStart"
              onChange={handleSelectReportStart}
              value={selectedReportStart}
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              id="reportEnd"
              className={classes.singleSelectField}
              label={intl.formatMessage({
                defaultMessage: "End Date",
                description: "select report end date"
              })}
              type="date"
              name="reportEnd"
              onChange={handleSelectReportEnd}
              value={selectedReportEnd}
              InputLabelProps={{
                color: "primary",
                shrink: true
              }}
            />
          </Grid>
        </DialogContent>
        <DialogActions className={classes.buttonActionFlex}>
          <div className={classes.buttonActions}>
            <Button
              onClick={onClose}
              variant="contained"
              color="default"
              className={classes.buttonWidth}
            >
              BACK
            </Button>
            <Button
              autoFocus
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              className={classes.buttonWidth}
            >
              DOWNLOAD
            </Button>
          </div>
        </DialogActions>
      </>
    </Dialog>
  );
};
GenerateReportDialog.displayName = "GenerateReportDialog";
export default GenerateReportDialog;
